export default __webpack_public_path__ + "static/media/saiPrachodhan.853d09e2.jpeg";